import { createAction } from '@reduxjs/toolkit';

import { mbcBulkAssignModule } from '../constants';

export const routeMBCBulkAssign = createAction(
  `${mbcBulkAssignModule}/ROUTE_MBC_BULK_ASSIGN`,
);

export const goToMBCBulkAssignRoute = createAction<{
  counselorMemberId: number;
}>(routeMBCBulkAssign.type);

export const ROUTE_MBC_BULK_ASSIGN = routeMBCBulkAssign.type;
